<template>
    <div>
        <div id="container" @dragover.prevent @drop.prevent>
            <Header />
            <router-view />
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import Header from './components/Header.vue'
import 'reset-css'
export default {
    name: 'App',
    components: {
        Header
    },
    data() {
        return {
            appHash: null,
        }
    },
    created: function () {
        this.$store.dispatch('holidays/fetch')
        this.currentAppHash()
        this.lifeCheck()
        this.updateCheck()

        document.addEventListener('visibilitychange', () => {
            if (document.visibilityState == 'visible') {
                this.fetchUserInfo()
            }
        })
    },
    computed: mapState([
        'isAuth',
        'userInfo',
    ]),
    watch: {
        isAuth: {
            handler: function (isAuth) {
                // 初回接続時(immediate) or ログイン変更時
                if (!isAuth) {
                    if (this.$route.name != 'Login') {
                        this.$router.push({ name: 'Login' })
                    }
                    return
                }
                this.fetchUserInfo()
                // 店舗一覧（tempo_code_settingsベース）を取得してservicesストアへ反映
                this.$store.dispatch('services/fetchShops')
            },
            immediate: true,
        },
        appHash: function (newAppHash, oldAppHash) {
            if (!oldAppHash) {
                return
            }
            this.$toast.info('アプリが更新されてます\nブラウザーを更新してください', { position: 'top-center', timeout: false })
        },
    },
    methods: {
        lifeCheck() {
            setInterval(this.fetchUserInfo, 60 * 60 * 1000)
        },
        updateCheck() {
            setInterval(this.fetchAppHash, 5 * 60 * 1000)
        },
        fetchUserInfo() {
            if (!this.isAuth) {
                return
            }

            if (this.$store.state.userInfo.userName == null) {
                this.axios.get('/api/getAuthenticatedUserName')
                    .then(res => {
                        this.$store.dispatch('userInfo', { userName: res.data.authenticatedUserName })
                    })
            }
        },
        async fetchAppHash() {
            const res = await this.axios.get('/index.html', {
                responseType: 'document',
                params: { cache: this.$dayjs().unix() },
            })
            const document = res.data
            this.getAppHash(document)
        },
        currentAppHash() {
            this.getAppHash(document)
        },
        getAppHash(document) {
            // 本番  <script src="/js/app.e24da489.js">
            // local <script type="text/javascript" src="/js/app.js">
            // hashの違いでアップデートを促す
            const src = document.querySelector('script[src^="/js/app."][src$=".js"]').getAttribute('src')
            this.appHash = src
        },
    },
}
</script>

<style lang="sass">
*
    box-sizing: border-box
html
    font-size: 62.5%
    overscroll-behavior-x: none;
body
    background: #F5F7F9
    #container
        height: 100vh
        position: relative
        width: 100%
        .containerInner
            height: calc(100% - 50px)
            position: relative
            top: 50px
            width: 100%
    // TODO: Componentでの実装にしたい
    .btn
        display: inline-block
        border: 1px solid $mainColor
        background: $mainColor
        color: $whiteColor
        cursor: pointer
        font-size: 1.4rem
        padding: 7px 10px
        text-align: center
        vertical-align: middle
        white-space: nowrap
        transition: 0.2s ease-out
        &:hover
            background: $whiteColor
            color: $grayColor
        &.borderNone:hover
            border-color: $whiteColor
        &.close
            font-size: 1.7rem
            width: 40px
            line-height: 38px
            padding: 0
        &.close::before
            content: '×'
        &.normal
            // TODO: デフォルトが$mainColorなのでほんとはnormalをデフォルトにしたい
            background: $whiteColor
            color: $grayColor
            &:hover
                background: #cfeee9
                color: $whiteColor
        &.primary
            // TODO: ルール決めてから実装 $mainColorをprimaryにしたい
        &.secondary
            // TODO: ルール決めてから実装
        &.accent
            // TODO: ルール決めてから実装
        &.small
            padding: 3px 5px
            font-size: 1.2rem
        &.xSmall
            padding: 1px 2px
            font-size: 1.0rem
        &.large
            font-size: 2.0rem
        &.xLarge
            font-size: 2.4rem
    .errorBalloon
        background: #FDD
        border: 2px solid #ff0000
        border-radius: 4px
        color: #ff0000
        p
            padding: 2px
        &:before
            content: ""
            z-index: 2
        &:after
            content: ""
            z-index: 1
a
    text-decoration: none
/* ページネーション */
.pagination
    border-radius: 4px
    display: inline-block
    font-size: 1.2rem
    left: 50%
    position: absolute
    transform: translateX(-50%)
    li
        display: inline
        a
            background: $whiteColor
            border: 1px solid #f8f8ff
            color: $mainColor
            float: left
            padding: 14px
            position: relative
            transition: 0.2s ease-out
            &:hover
                background: #eee
                border-color: #ddd
                color: #23527c
                z-index: 3
    .active
        a
            background: $mainColor
            border-color: $mainColor
            color: $whiteColor
            cursor: default
            z-index: 2
            &:hover
                background-color: $mainColor
                border-color: $mainColor
                color: $whiteColor
                z-index: 3
    .disabled
        a
            cursor: not-allowed
/* カレンダー */
.calendarDate
    color: $grayColor
    left: 10px
    top: 40px
    .up, .prev, .next, .day:not(.blank), .month, .year
        &:hover
            background: $mainColor !important
            color: $whiteColor
            transition: 0.2s ease-out
    .prev
        &:hover
            &::after
                border-right: 10px solid $whiteColor
    .next
        &:hover
            &::after
                border-left: 10px solid $whiteColor
    .selected
        background: $mainColor
        color: $whiteColor
.inputDate
    margin: 0 10px
    padding: 5px
    width: 100px
    &:focus
        outline: 2px solid $mainColor
.vdp-datepicker__calendar
    .cell.day, .cell.day-header
        &:nth-child(7n+7)
            color: #55f
            &.disabled
                color: #a3a3f3
    .cell.day, .cell.day-header
        &.highlighted, &:nth-child(7n+1)
            background: inherit
            color: #f55
            &.disabled
                color: #f3a3a3
    .cell.selected
        background: $mainColor !important
/* プルダウンメニュー */
.v-select
    background: $mainColor
    height: 30px
    .vs__dropdown-toggle
        border-radius: 0
        cursor: pointer !important
        height: 30px
        min-width: 220px
        padding: 0
        .vs__selected
            color: $whiteColor
        .vs__search
            cursor: pointer !important
        .vs__clear
            display: none
        .vs__actions
            display: none
        .vs__open-indicator
            fill: rgba(255,255,255,1)
        .vs__dropdown-option--highlight
            background: $mainColor !important
    .vs__dropdown-menu
        border-radius: 0

@include sp()
    body
        #container
            width: 100%
    .vdp-datepicker
        input
            width: 82px
            margin: 0 3px
            font-size: 12px
    .vdp-datepicker__calendar
        width: 200px !important
        left: -55px
    .v-select
        height: 26px
        .vs__selected
            margin: 0
        .vs__dropdown-toggle
            height: 26px
            min-width: 60px !important
        .vs__dropdown-menu
            min-width: 60px !important
</style>
